import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOne from "../components/DashBoardLayerOne";

const HomePageOne = () => {
  return (
    <>
      {/* MasterLayout */}
        {/* Breadcrumb */}
        <Breadcrumb title="AI" />


        {/* DashBoardLayerOne */}
        <DashBoardLayerOne />

    </>
  );
};

export default HomePageOne;
